import { useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';

import Grid from '@mui/material/Grid2';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

//Our Imports
import bg1 from '../../../assets/img/offers/bg1.png';
import bg2 from '../../../assets/img/offers/bg2.png';
import bg3 from '../../../assets/img/offers/bg3.png';
import cont1 from '../../../assets/img/offers/cont1.svg';	
import cont3 from '../../../assets/img/offers/cont3.svg';
import investment from '../../../assets/img/offers/investment.gif';
import savings from '../../../assets/img/offers/savings.gif';
import loan from '../../../assets/img/offers/loan.gif';
import interest from '../../../assets/img/offers/interest.gif';
import { AnimatedText, CustomButton } from '../../../assets/component/initComponent';
import useInView from '../../../hooks/useInView';


const Offers = ({ viewOnce = true, navTrigger }) => {

	//InView Hook
	const [sectionRef, inView] = useInView();
	const controls = useAnimation();

	// ref 
	const hasAnimatedOnScroll = useRef(false);

	const weOffer = [
		{
			id: 1,
			title: 'Popular calculators',
			desc: 'A collection of most-used calculators designed for quick, accurate, and convenient financial planning.',
			btnTitle: 'Read More About',
			bgcolor: '#5B31A1',
			color: '#fff',
			bgImg: bg1,
			content: cont1
		},
		{
			id: 2,
			title: 'Category',
			desc: 'Structured categories that make exploring and using financial calculators simple and efficient.',
			btnTitle: 'Get Started For Free',
			bgcolor: '#BEF053',
			color: '#000',
			bgImg: bg2
		},
		{
			id: 3,
			title: 'Reports',
			desc: 'Clearly organized results and summaries to understand your financial calculations.',
			btnTitle: 'Read More About',
			bgcolor: '#5B31A1',
			color: '#fff',
			bgImg: bg3,
			content: cont3
		}
	];

	const categoryList = [
		{ title: 'Investment', img: investment },
		{ title: 'Savings', img: savings },
		{ title: 'Loan & EMI', img: loan },
		{ title: 'Interest', img: interest }
	];

	// Parent controls the timing (stagger)
	const containerVariant = {
		hidden: {},
		visible: {
			transition: {
				staggerChildren: 0.2,   // delay between cards
				delayChildren: 0.4
			}
		}
	};

	// Each card animation
	const cardVariant = {
		hidden: {
			opacity: 0,
			y: 100
			// scale: 0.90
		},
		visible: {
			opacity: 1,
			y: 0,
			scale: 1,
			transition: {
				duration: 2,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	//Trigger Animation for Nav Click
	useEffect(() => {
		if (navTrigger) {
			controls.start('hidden').then(() => {
				controls.start('visible');
			});
		}
	}, [navTrigger, controls]);

	useEffect(() => {
		if (inView && !hasAnimatedOnScroll.current) {
			controls.start('visible');
			hasAnimatedOnScroll.current = true; // lock it
		}
	}, [inView, controls]);

	return(
		<Container className='containerFull' ref={sectionRef}>
			
			<Grid container spacing={2} direction='column' alignItems='center' mb={6}>
				<Box className='titleWithBg' sx={{ width: 'max-content' }}>
					<Typography variant='h2' component='h2' className='font25'>What we offer</Typography>
				</Box>
				<AnimatedText
					title={'Digital Platform Designed To Simplify Financial <br/> Planning Through Smart Calculators For Finance Needs'}
					hightLight={['Smart', 'Calculators']}
					className='font40 txtCenter fontBolder textCl'
					// animate={controls}
				/>
			</Grid>
			<motion.div
				variants={containerVariant}
				initial='hidden'
				// animate={controls}
				whileInView='visible'
				viewport={{ once: viewOnce, margin: '-160px' }}
			>
				<Grid container spacing={4} justifyContent='center'>
					{weOffer.map((point, pointIndex) => {
						return(
							<Grid size={{ lg: 4, md: 6, sm: 6, xs: 12 }} key={pointIndex} className='offerParent'>
								<motion.div
									variants={cardVariant}
									// whileHover={{ y: -8 }}
									transition={{ type: 'spring', stiffness: 200, damping: 18 }}
									style={{ height: '100%' }}
								>
									<Grid container spacing={4} p={{ md: 4, xs: 3 }} direction='column' justifyContent='space-between' sx={{ bgcolor: point.bgcolor, color: point.color, borderRadius: '15px', height: '100%' }}>
										<Grid size={12} className='offerImgBox' sx={{ backgroundImage: `url(${point.bgImg})` }}>
											{point.id === 2 ?
												<Grid container spacing={2} sx={{ color: '#fff' }} p={2} className='glassBg'>
													<Grid size={12} display='flex' justifyContent='space-between' alignItems='center'>
														<Typography className='font14'>Category</Typography>
														<Typography className='font14'>see all</Typography>
													</Grid>
													<Grid size={12}>
														<Grid container spacing={1} py={2} px={1} sx={{ bgcolor: '#121111', borderRadius: '12px' }}>
															{categoryList.map((cat, catIndex) => (
																<Grid size={3} key={catIndex} sx={{ textAlign: 'center', justifyItems: 'center' }}>
																	<Box className='mb5' sx={{ bgcolor: '#fff', borderRadius: '50%', width: '40px', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
																		<img src={cat.img} height='30px' alt='category'/>
																	</Box>
																	<Typography className='font10'>{cat.title}</Typography>
																</Grid>
															))}
														</Grid>
													</Grid>
												</Grid>
												:
												<img src={point.content} height='100%' width='100%' style={{ objectFit: 'contain' }} alt='point'/>
											}
										</Grid>
										<Grid size={12}>
											<Typography component='h3' className='fontBold mb10 font25'>{point.title}</Typography>
											<Typography className='font17'>{point.desc}</Typography>
										</Grid>
										<Grid size={12}>
											<CustomButton color={point.id === 2 ? '#fff' : point.bgcolor} bgcolor={point.color}>{point.btnTitle}</CustomButton>
										</Grid>
									</Grid>
								</motion.div>
							</Grid>
						);
					})}
				</Grid>
			</motion.div>
		</Container>
	);
};

export default Offers;
